/**
 * Pre-compiled es messages for ScopedSearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { searchLabel: `Buscar`, selectLabel: `Filtrar por` };
